/* Biomed - Omaggio automatico (sostituisce l'app Monster Cart, disattivata).
   Soglia = settings.free_minimum_amount del tema (la stessa della barra), omaggio = ID VARIANTE (mai l'handle, che Shopify puo cambiare):
   arrivano da theme.liquid in window.BM_GIFT = { threshold_cents, variant_id, money_format }.
   Dopo ogni /cart/add, /cart/change, /cart/update, /cart/clear (fetch e XHR del tema o di altri script; le nostre chiamate usano il fetch
   originale e non rientrano) e al caricamento della pagina carrello si legge /cart.js:
   - totale SENZA l'omaggio >= soglia e omaggio assente: aggiunge 1 pezzo; sotto soglia e presente: lo toglie; quantita diversa da 1: la riporta a 1;
   - una sola operazione alla volta (lock); le richieste che arrivano nel frattempo causano al massimo un secondo controllo, mai un ciclo.
   Fuori dal carrello solo le chiamate, nessun reload. Nel carrello aggiorna le sezioni (id letti dal DOM, ripiego: reload).
   Espone anche window.BM_CART (sectionIds, applySections, afterUpdate), usato dal consulente per le sue aggiunte. */
(function () {
  'use strict';
  var G = window.BM_GIFT || {};
  var origFetch = window.fetch;
  if (!origFetch || window.__bmFreeGiftLoaded) return;
  window.__bmFreeGiftLoaded = true;

  /* --- sezioni del carrello (condivise con il consulente) --- */
  function parseHtml(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function money(cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return String(G.money_format || '{{amount}} €').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v).replace(/<[^>]+>/g, '');
  }
  /* id reali delle sezioni, letti dal DOM (con i template JSON sono del tipo "template--123__cart-items") */
  function sectionIds() {
    var ids = [];
    function add(id) { if (id && ids.indexOf(id) < 0) ids.push(id); }
    document.querySelectorAll('.shopify-section').forEach(function (el) {
      if (/__cart-items|__cart-upsell|cart-icon-bubble/.test(el.id)) add(el.id.replace('shopify-section-', ''));
    });
    var mc = document.querySelector('main-cart');
    add(mc && mc.getAttribute('data-section-id'));
    add('cart-icon-bubble'); /* sezione a se stante del tema: contatore dell'header */
    return ids;
  }
  /* aggiorna la pagina carrello con le sezioni restituite dal server, con gli stessi frammenti del tema. false se non puo. */
  function applySections(sections) {
    var mc = document.querySelector('main-cart');
    var mainId = mc && mc.getAttribute('data-section-id');
    var html = sections && mainId && sections[mainId];
    if (!html) return false;
    var doc = parseHtml(html);
    if (!doc.querySelector('.main-cart-items')) return false;
    ['.main-cart-items', '.cart-info .totals', '.cart-recommendations', '.checkout__sticky__wrapper'].forEach(function (sel) {
      var cur = mc.querySelector(sel) || document.querySelector(sel), nxt = doc.querySelector(sel);
      if (cur && nxt) cur.innerHTML = nxt.innerHTML;
    });
    /* barra spedizione gratuita: come fa il tema, si aggiorna solo il totale e il testo lo ricalcola FSProgressBar */
    var bar = document.querySelector('.free-shipping-bar'), nbar = doc.querySelector('.free-shipping-bar');
    if (bar && nbar) {
      var pr = bar.querySelector('.progress'), npr = nbar.querySelector('.progress');
      if (pr && npr) pr.setAttribute('data-total-order', npr.getAttribute('data-total-order'));
      else bar.innerHTML = nbar.innerHTML;
    }
    document.querySelectorAll('.shopify-section[id*="__cart-upsell"]').forEach(function (el) {
      var key = el.id.replace('shopify-section-', ''), h = sections[key];
      if (!h) return;
      var n = parseHtml(h).querySelector('.shopify-section'); if (n) el.innerHTML = n.innerHTML;
    });
    if (sections['cart-icon-bubble']) {
      var cnt = parseHtml(sections['cart-icon-bubble']).querySelector('.cart-count');
      ['cart-icon-bubble', 'cart-icon-bubble-mobile'].forEach(function (bid) {
        var el = document.getElementById(bid), c = el && el.querySelector('.cart-count');
        if (c && cnt) c.innerHTML = cnt.innerHTML;
      });
    }
    return true;
  }
  /* il tema espone i suoi helper come modulo ES (import map "@NextSkyTheme/global"): lo carica un <script type="module"> inline */
  if (document.querySelector('main-cart')) {
    try {
      var sc = document.createElement('script');
      sc.type = 'module';
      sc.textContent = "import * as m from '@NextSkyTheme/global'; window.__bmTheme = m;";
      document.head.appendChild(sc);
    } catch (e) {}
  }
  /* stessa logica di FSProgressBar del tema, solo se il modulo non e' disponibile */
  function updateShippingBar() {
    var bar = document.querySelector('.free-shipping-bar');
    var pr = bar && bar.querySelector('.progress');
    if (!pr) return;
    var rate = Number(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
    var min = Number(pr.dataset.feAmount) * rate * 100, total = Number(pr.dataset.totalOrder) || 0;
    if (!min) return;
    pr.style.setProperty('--width', Math.min(100, total / min * 100) + '%');
    var msg = bar.querySelector('.progress-bar-message');
    if (!msg) return;
    if (total >= min) { msg.innerHTML = bar.dataset.feAvailable || ''; bar.classList.add('free-shipping'); }
    else if (bar.dataset.feUnavailable) {
      bar.classList.remove('free-shipping');
      msg.innerHTML = bar.dataset.feUnavailable.replace('[amount]', '<span class="price heading-color">[amount]</span>').replace('[amount]', money(min - total));
    }
  }
  function afterUpdate() {
    var m = window.__bmTheme;
    if (m) {
      try { m.publish(m.PUB_SUB_EVENTS.cartUpdate, { source: 'bm-advisor' }); } catch (e) {}
      try { new m.FSProgressBar('free-ship-progress-bar'); } catch (e) { updateShippingBar(); }
    } else updateShippingBar();
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }
  window.BM_CART = { sectionIds: sectionIds, applySections: applySections, afterUpdate: afterUpdate };

  /* --- omaggio --- */
  var onCartPage = function () { return !!document.querySelector('main-cart'); };
  function threshold() {
    var rate = Number(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
    return (Number(G.threshold_cents) || 0) * rate;
  }
  function track(name, data) {
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, data)); } catch (e) {}
  }
  function readCart() {
    return origFetch.call(window, '/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  function post(url, body) {
    var withSections = onCartPage();
    if (withSections) { body.sections = sectionIds().join(','); body.sections_url = window.location.pathname; }
    return origFetch.call(window, url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok && !j.status, json: j }; }); });
  }
  var giftId = Number(G.variant_id) || 0;
  if (!giftId) { try { console.warn('[bm-free-gift] BM_GIFT.variant_id mancante: omaggio automatico disattivato (layout/theme.liquid)'); } catch (e) {} }
  function isGift(it) { return !!giftId && Number(it.variant_id) === giftId; }

  function done(action, res, hasGift, total) {
    if (onCartPage()) {
      var ok = false;
      try { ok = applySections(res.json && res.json.sections); } catch (e) { ok = false; }
      if (!ok) { window.location.reload(); return; }
      afterUpdate();
    }
    if (action === 'added') track('bm_free_gift_added', { variant_id: giftId, cart_total: total });
    if (action === 'removed') track('bm_free_gift_removed', { variant_id: giftId, cart_total: total });
    try { document.dispatchEvent(new CustomEvent('bm-free-gift:changed', { detail: { action: action, has_gift: hasGift, total: total } })); } catch (e) {}
  }

  function sync() {
    return readCart().then(function (cart) {
      if (!cart || !giftId) return;
      var lines = (cart.items || []).filter(isGift);
      var qty = lines.reduce(function (t, it) { return t + it.quantity; }, 0);
      var total = (cart.total_price || 0) - lines.reduce(function (t, it) { return t + (it.final_line_price || 0); }, 0);
      var min = threshold();
      if (min && total >= min) {
        if (!lines.length) {
          /* update.js con quantita assoluta (e non add.js): se la scheda prodotto e il carrello lo fanno insieme non nasce un 2 */
          var upAdd = {}; upAdd[String(giftId)] = 1;
          return post('/cart/update.js', { updates: upAdd })
            .then(function (res) { if (res.ok) done('added', res, true, total); });
        }
        if (qty !== 1 || lines.length > 1) {
          var up = {}; lines.forEach(function (it, i) { up[it.key] = i === 0 ? 1 : 0; });
          return post('/cart/update.js', { updates: up }).then(function (res) { if (res.ok) done('fixed', res, true, total); });
        }
      } else if (lines.length) {
        var rm = {}; lines.forEach(function (it) { rm[it.key] = 0; });
        return post('/cart/update.js', { updates: rm }).then(function (res) { if (res.ok) done('removed', res, false, total); });
      }
    });
  }

  var busy = false, again = false, timer = null;
  function run() {
    if (busy) { again = true; return; }
    busy = true;
    sync().catch(function () {}).then(function () { busy = false; if (again) { again = false; run(); } });
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(run, 150); }

  /* intercetta le modifiche del carrello fatte dal tema o dal consulente */
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var urlOf = function (input) { return typeof input === 'string' ? input : (input && (input.url || String(input))) || ''; };
  window.fetch = function (input) {
    var p = origFetch.apply(this, arguments);
    try { if (CART_RE.test(urlOf(input))) p.then(schedule, function () {}); } catch (e) {}
    return p;
  };
  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    var hit = CART_RE.test(String(url || ''));
    if (hit) this.addEventListener('loadend', schedule);
    return xhrOpen.apply(this, arguments);
  };

  /* pagina carrello: controllo al caricamento */
  if (onCartPage()) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
  }
})();
